import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import { RewardsEmptyStatePageWidgetDefinition } from "@apps/rewards/constants/definitions";
import type { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";

class RewardsEmptyStatePageWidgetInjector {
    constructor(private readonly config: RewardsWidgetInjectorConfig) {}

    start(): void {
        this.config.logger.debug("RewardsEmptyStatePageWidgetInjector start", {
            placeholderSelector: this.config.placeholderSelector,
        });

        const widgetName = REWARDS_WIDGET_NAMES.REWARDS_EMPTY_STATE_PAGE_WIDGET;

        const targets$ = this.config.mutationObserverInjector.register({
            targetSelector: this.config.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.config.logger?.debug(
                "RewardsEmptyStatePageWidgetInjector found placeholder",
                {
                    placeholder,
                }
            );

            void (async () => {
                const RewardsEmptyStatePageWidget =
                    await this.config.dynamicImportManager.importDefault(
                        RewardsEmptyStatePageWidgetDefinition,
                        true
                    );

                const widget = new RewardsEmptyStatePageWidget(
                    {
                        target: placeholder,
                    },
                    this.config.logger
                );

                widget.init();

                this.config.eventsCollector.pushEvent(
                    this.config.eventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default RewardsEmptyStatePageWidgetInjector;
